<template>
    <div class="tab-bar">
        <router-link
            to="/store_shop_list"
            class="tab-item"
            active-class="active"
        >
            <div class="tab-icon">
                <img
                    :src="activeTab === 'store_shop_list' ? bar2 : bar1"
                    alt="商品"
                    class="tab-img"
                />
            </div>
            <div class="tab-text">商品</div>
        </router-link>

        <router-link to="/store_cart" class="tab-item" active-class="active">
            <div class="tab-icon">
                <img
                    :src="activeTab === 'store_cart' ? bar6 : bar5"
                    alt="购物车"
                    class="tab-img"
                />
            </div>
            <div class="tab-text">购物车</div>
        </router-link>

        <router-link to="/store_order" class="tab-item" active-class="active">
            <div class="tab-icon">
                <img
                    :src="activeTab === 'store_order' ? bar3 : bar4"
                    alt="订单"
                    class="tab-img"
                />
            </div>
            <div class="tab-text">订单</div>
        </router-link>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import bar1 from "@/assets/img/shoptabbar/bar-1.png";
import bar2 from "@/assets/img/shoptabbar/bar-1-1.png";
import bar3 from "@/assets/img/shoptabbar/bar-2-2.png";
import bar4 from "@/assets/img/shoptabbar/bar-2.png";
import bar5 from "@/assets/img/shoptabbar/bar-3.png";
import bar6 from "@/assets/img/shoptabbar/bar-3-3.png";

const activeTab = ref("store_shop_list");
const route = useRoute();
const router = useRouter();

const updateActiveTab = () => {
    const path = route.path;
    if (path.includes("/store_shop_list")) {
        activeTab.value = "store_shop_list";
    } else if (path.includes("/store_cart")) {
        activeTab.value = "store_cart";
    } else if (path.includes("/store_order")) {
        activeTab.value = "store_order";
    }
};

onMounted(() => {
    updateActiveTab();
});

// 监听路由变化
watch(
    () => route.path,
    () => {
        updateActiveTab();
    }
);
</script>

<style lang="less" scoped>
.tab-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 70px;
    background-color: #fff;
    border-top: 1px solid #f6f6f6;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding-bottom: env(safe-area-inset-bottom, 0); // 适配刘海屏
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.tab-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-decoration: none;
}

.tab-icon {
    width: 24px;
    height: 24px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tab-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.tab-text {
    font-size: 11px;
    line-height: 15px;
    color: #5f4b2d;
    font-weight: 500;
}

.tab-item.active .tab-text {
    background: linear-gradient(135deg, #ff7123, #ffb45b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
}
</style>
